module.exports = __WEBPACK_EXTERNAL_MODULE_14__;


//////////////////
// WEBPACK FOOTER
// external {"amd":"openfl/geom/Point","root":["openfl","geom","Point"],"commonjs":"openfl/geom/Point","commonjs2":"openfl/geom/Point"}
// module id = 14
// module chunks = 0